import React from 'react';

/**
 * THE-1084 PR4 — the gift icon a `kind: 'LINK'` saved item shows in place of
 * a photo, everywhere a saved item's image area appears (grid tile, detail
 * page, saves-tray/strip/pill thumbnails): an added link is never fetched,
 * so it never has one. Hoisted here (the `TuneGlyph.tsx` convention) rather
 * than copied per call site — this mark now renders in ~8 places across the
 * board, saved pages and shared list, and a drifted copy would read as a
 * different icon.
 *
 * `currentColor` on purpose — every call site tints it against its own
 * neutral-fill background.
 *
 * `size` also takes a CSS percentage string (e.g. the grid tile and detail
 * page pass `"25%"` — Kate, board QA on #836 — so the icon scales with the
 * tile instead of reading tiny against it at every breakpoint). The SVG's
 * default `preserveAspectRatio` keeps the glyph itself square even when the
 * box percentages resolve to a non-square box.
 */
export const AddedLinkGlyph: React.FC<{ size?: number | string }> = ({ size = 22 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="8" width="18" height="4" rx="1" />
    <path d="M12 8v12.5" />
    <path d="M19 12v6.5a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V12" />
    <path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 5.5 12 8M16.5 8a2.5 2.5 0 0 0 0-5C14 3 12 5.5 12 8" />
  </svg>
);

export default AddedLinkGlyph;
